import React from 'react';
import { Text } from '@amzn/storm-ui-v3';
import { useTranslateMapItem } from '@urc-ui/hooks/translate-map';
import { REPORT_TYPE_TRANSLATION_MAP, getReportTypeTranslationKey, REPORT_TYPE, RMS_REPORT_TYPE } from '@urc-ui/utils/report-type-utils';
import { REPORT_CATEGORY } from '@urc-ui/utils/types';
import { StyledCellWrapper } from '@urc-ui/components/styles';

type Props = {
  value: {
    programType: REPORT_CATEGORY;
    reportType: REPORT_TYPE | RMS_REPORT_TYPE;
  };
};

export function ReportTypeCell(props: Props) {
  const { programType, reportType } = props.value;
  const reportTypeTranslationKey = getReportTypeTranslationKey(reportType, programType);
  const text = useTranslateMapItem(REPORT_TYPE_TRANSLATION_MAP, reportTypeTranslationKey);

  return (
    <StyledCellWrapper>
      <Text fontSize='small'>{text}</Text>
    </StyledCellWrapper>
  );
}
